<div *ngIf="clientNote && clientNote.Note">
  <label class="fw-bold">Notes</label>
  <div class="card card--light card--short p-3 pre">{{ clientNote.Note }}</div>
</div>
